// This store is meant to keep selection data for full transcript and timeline in one place

import createStore from './store';

export const defaultTimelineSelectionState = {
  startSegmentId: null,
  endSegmentId: null,
  startTime: null,
  endTime: null,
  isSelecting: false,
  selectedDeleteIndex: null,
  selectedSegmentId: null,
  isTimelineSelect: false
};

export const transcriptTimelineSelectionStore = createStore<{
  // Start and End time don't include the offset of the composite segment
  startTime: number | null;
  endTime: number | null;
  startSegmentId: string | null;
  endSegmentId: string | null;
  isSelecting: boolean;
  // Choose to use index instead of delete start time to avoid maintaining redundant transition values of deletes while dragging operation.
  selectedDeleteIndex: number | null;
  selectedSegmentId: string | null;
  isTimelineSelect?: boolean;
}>({
  ...defaultTimelineSelectionState
});
